var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-419.000000, -1243.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heart",
    transform: "translate(419.000000, 1243.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Heart-Copy-7",
    mask: "url(#mask-2)",
    stroke: "#484888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 4.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,16.2000013 C11.7691991,14.8154013 15.0609991,11.7831013 16.6191991,9.46590125 C18.1772991,7.14870125 18.7230991,3.78955125 16.6191991,1.62410125 C14.5151991,-0.54135875 11.1039991,-0.54135875 9,1.62410125 C6.89602905,-0.54135875 3.48480905,-0.54136875 1.38083905,1.62408125 C-0.723130946,3.78954125 -0.177310946,7.14870125 1.38083905,9.46590125 C2.93898905,11.7831013 6.23076905,14.8154013 9,16.2000013 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartEmpty);
export default __webpack_public_path__ + "static/media/heart-empty.c6906c628862858ef1cd6324ef4fdef1.svg";
export { ForwardRef as ReactComponent };